import { SidebarStatsParams } from '@/types/sidebarStats';

export const userQueryKeys = {
  me: ['auth', 'me'] as const,
  sidebarStats: (params: SidebarStatsParams) =>
    ['auth', 'sidebar-stats', params] as const,
  dashboardStats: ['auth', 'dashboard-stats'] as const,
  userTransactions: (page: number, limit = 10) =>
    ['auth', 'user-transactions', page, limit] as const,
  aiHistory: (page: number, limit = 10) =>
    ['auth', 'ai-history', page, limit] as const,
  userTransaction: (transactionId: number) =>
    ['auth', 'user-transaction', transactionId] as const,
  transactionSummary: ['auth', 'transaction-summary'] as const,
} as const;
